/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/* Template custom: api */

import {
  ApiAssetExtractResponse,
  ApiBatchByUriInput,
  ApiBatchStartResponse,
  ApiBodyFamilyCassaPaymentFromPdfFamilyCassaPaymentFromPdfPost,
  ApiBodyHttpExtractAssetFromFilesExtractAssetFromFilesPost,
  ApiBodyHttpExtractBatchExtractBatchPost,
  ApiBodyHttpExtractFromImagesExtractFromImagesPost,
  ApiDocumentExtractByUriInput,
  ApiExtractFromImagesResponse,
  ApiFamilyCassaExecutePaymentRequest,
  ApiFamilyCassaExecutePaymentResponse,
  ApiFamilyCassaPaymentFromPdfResponse,
  ApiFamilyCassaPaymentFromTextRequest,
  ApiFamilyCassaPaymentResponse,
  ApiFamilyCassaRoutingApprovalRequest,
  ApiFamilyCassaRoutingApprovalResponse,
  ApiFamilyCassaWiseCreateRecipientAbaRequest,
  ApiFamilyCassaWiseCreateRecipientIbanRequest,
  ApiFamilyCassaWiseCreateRecipientResponse,
  ApiFamilyCassaWiseCreateRecipientSwiftRequest,
  ApiFamilyCassaWiseCreateTransferRequest,
  ApiFamilyCassaWiseCreateTransferResponse,
  ApiFamilyCassaWiseDepositDetailsRequest,
  ApiFamilyCassaWiseDepositDetailsResponse,
  ApiFamilyCassaWiseFundTransferRequest,
  ApiFamilyCassaWiseFundTransferResponse,
  ApiFamilyCassaWisePatchQuoteRequest,
  ApiFamilyCassaWisePatchQuoteResponse,
  ApiFamilyCassaWisePrepareRequest,
  ApiFamilyCassaWisePrepareResponse,
  ApiJobDocument,
  ApiJobListResponse,
} from "./data-contracts";
import {
  ApiBaseError,
  ContentType,
  HttpClient,
  RequestParams,
} from "./http-client";

export class GtwLlmSocket<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /* Template custom: procedure-call */
  /**
   * @description Extract a structured Family Cassa payment entity from raw invoice text using a fixed Azure GPT model (azure-gpt-5.2), then apply deterministic routing and approval rules.
   *
   * @tags Family Cassa
   * @name FamilyCassaPaymentFromTextFamilyCassaPaymentFromTextPost
   * @summary Extract Family Cassa payment from invoice text
   * @request POST:/gtw/llm-socket/family-cassa/payment/from-text
   * @secure
   * @response `200` `ApiFamilyCassaPaymentResponse` Structured payment extracted and enriched with routing/approval.
   * @response `400` `void` Validation error
   * @response `401` `void` Unauthorized
   * @response `422` `ApiHTTPValidationError` Validation Error
   * @response `500` `void` Internal server error
   */
  familyCassaPaymentFromTextFamilyCassaPaymentFromTextPost = (
    data: ApiFamilyCassaPaymentFromTextRequest,
    params: RequestParams = {},
  ) =>
    this.request<ApiFamilyCassaPaymentResponse, ApiBaseError>({
      path: `/gtw/llm-socket/family-cassa/payment/from-text`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * @description Ingest a single PDF invoice, extract a structured Family Cassa payment entity using a fixed Azure GPT model (azure-gpt-5.2), then apply deterministic routing and approval rules.
   *
   * @tags Family Cassa
   * @name FamilyCassaPaymentFromPdfFamilyCassaPaymentFromPdfPost
   * @summary Extract Family Cassa payment from a PDF invoice
   * @request POST:/gtw/llm-socket/family-cassa/payment/from-pdf
   * @secure
   * @response `200` `ApiFamilyCassaPaymentFromPdfResponse` Structured payment extracted from PDF and enriched with routing/approval.
   * @response `400` `void` Validation or ingest error
   * @response `401` `void` Unauthorized
   * @response `422` `ApiHTTPValidationError` Validation Error
   * @response `500` `void` Internal server error
   */
  familyCassaPaymentFromPdfFamilyCassaPaymentFromPdfPost = (
    data: ApiBodyFamilyCassaPaymentFromPdfFamilyCassaPaymentFromPdfPost,
    params: RequestParams = {},
  ) =>
    this.request<ApiFamilyCassaPaymentFromPdfResponse, ApiBaseError>({
      path: `/gtw/llm-socket/family-cassa/payment/from-pdf`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.FormData,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * @description Apply deterministic routing and approval rules to an existing Family Cassa payment entity.
   *
   * @tags Family Cassa
   * @name FamilyCassaEvaluateRoutingApprovalFamilyCassaPaymentEvaluateRoutingApprovalPost
   * @summary Evaluate routing and approval decisions for a Family Cassa payment
   * @request POST:/gtw/llm-socket/family-cassa/payment/evaluate-routing-approval
   * @secure
   * @response `200` `ApiFamilyCassaRoutingApprovalResponse` Payment entity enriched with routing and approval decisions.
   * @response `400` `void` Validation error
   * @response `401` `void` Unauthorized
   * @response `422` `ApiHTTPValidationError` Validation Error
   * @response `500` `void` Internal server error
   */
  familyCassaEvaluateRoutingApprovalFamilyCassaPaymentEvaluateRoutingApprovalPost =
    (data: ApiFamilyCassaRoutingApprovalRequest, params: RequestParams = {}) =>
      this.request<ApiFamilyCassaRoutingApprovalResponse, ApiBaseError>({
        path: `/gtw/llm-socket/family-cassa/payment/evaluate-routing-approval`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      });
  /* Template custom: procedure-call */
  /**
   * @description Decide whether the given payment should be executed immediately, scheduled for later, or held awaiting manual approval. This endpoint does not directly contact external payment providers; instead, it returns a normalized execution plan that upstream payment orchestrators can consume.
   *
   * @tags Family Cassa
   * @name FamilyCassaExecutePaymentFamilyCassaPaymentExecutePost
   * @summary Plan or execute a Family Cassa payment
   * @request POST:/gtw/llm-socket/family-cassa/payment/execute
   * @secure
   * @response `200` `ApiFamilyCassaExecutePaymentResponse` Execution decision for the payment (executed, scheduled, or requires manual approval).
   * @response `400` `void` Validation error
   * @response `401` `void` Unauthorized
   * @response `422` `ApiHTTPValidationError` Validation Error
   * @response `500` `void` Internal server error
   */
  familyCassaExecutePaymentFamilyCassaPaymentExecutePost = (
    data: ApiFamilyCassaExecutePaymentRequest,
    params: RequestParams = {},
  ) =>
    this.request<ApiFamilyCassaExecutePaymentResponse, ApiBaseError>({
      path: `/gtw/llm-socket/family-cassa/payment/execute`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * @description Prepare a Wise transfer by creating a quote and fetching dynamic account requirements. This is intended for building a "smart import" UI flow.
   *
   * @tags Family Cassa
   * @name FamilyCassaWisePrepareFamilyCassaWisePreparePost
   * @summary Wise smart import: create quote and fetch recipient requirements
   * @request POST:/gtw/llm-socket/family-cassa/wise/prepare
   * @secure
   * @response `200` `ApiFamilyCassaWisePrepareResponse` Quote created and account requirements returned.
   * @response `400` `void` Validation error
   * @response `401` `void` Unauthorized
   * @response `422` `ApiHTTPValidationError` Validation Error
   * @response `500` `void` Internal server error
   */
  familyCassaWisePrepareFamilyCassaWisePreparePost = (
    data: ApiFamilyCassaWisePrepareRequest,
    params: RequestParams = {},
  ) =>
    this.request<ApiFamilyCassaWisePrepareResponse, ApiBaseError>({
      path: `/gtw/llm-socket/family-cassa/wise/prepare`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * @description Create a Wise recipient account (IBAN) using a PaymentEntity and explicit address fields.
   *
   * @tags Family Cassa
   * @name FamilyCassaWiseCreateRecipientIbanFamilyCassaWiseRecipientIbanPost
   * @summary Wise smart import: create IBAN recipient with user-provided address
   * @request POST:/gtw/llm-socket/family-cassa/wise/recipient/iban
   * @secure
   * @response `200` `ApiFamilyCassaWiseCreateRecipientResponse` Recipient created.
   * @response `400` `void` Validation error
   * @response `401` `void` Unauthorized
   * @response `422` `ApiHTTPValidationError` Validation Error
   * @response `500` `void` Internal server error
   */
  familyCassaWiseCreateRecipientIbanFamilyCassaWiseRecipientIbanPost = (
    data: ApiFamilyCassaWiseCreateRecipientIbanRequest,
    params: RequestParams = {},
  ) =>
    this.request<ApiFamilyCassaWiseCreateRecipientResponse, ApiBaseError>({
      path: `/gtw/llm-socket/family-cassa/wise/recipient/iban`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * @description Create a Wise USD recipient account using US bank details (ABA routing + account number).
   *
   * @tags Family Cassa
   * @name FamilyCassaWiseCreateRecipientAbaFamilyCassaWiseRecipientAbaPost
   * @summary Wise smart import: create USD recipient with ABA routing/account
   * @request POST:/gtw/llm-socket/family-cassa/wise/recipient/aba
   * @secure
   * @response `200` `ApiFamilyCassaWiseCreateRecipientResponse` Recipient created.
   * @response `400` `void` Validation error
   * @response `401` `void` Unauthorized
   * @response `422` `ApiHTTPValidationError` Validation Error
   * @response `500` `void` Internal server error
   */
  familyCassaWiseCreateRecipientAbaFamilyCassaWiseRecipientAbaPost = (
    data: ApiFamilyCassaWiseCreateRecipientAbaRequest,
    params: RequestParams = {},
  ) =>
    this.request<ApiFamilyCassaWiseCreateRecipientResponse, ApiBaseError>({
      path: `/gtw/llm-socket/family-cassa/wise/recipient/aba`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * @description Create a Wise recipient for SWIFT transfers. Use this for USD/non-SEPA cases where IBAN recipient type is not valid.
   *
   * @tags Family Cassa
   * @name FamilyCassaWiseCreateRecipientSwiftFamilyCassaWiseRecipientSwiftPost
   * @summary Wise smart import: create recipient for SWIFT transfers (USD/non-SEPA)
   * @request POST:/gtw/llm-socket/family-cassa/wise/recipient/swift
   * @secure
   * @response `200` `ApiFamilyCassaWiseCreateRecipientResponse` Recipient created.
   * @response `400` `void` Validation error
   * @response `401` `void` Unauthorized
   * @response `422` `ApiHTTPValidationError` Validation Error
   * @response `500` `void` Internal server error
   */
  familyCassaWiseCreateRecipientSwiftFamilyCassaWiseRecipientSwiftPost = (
    data: ApiFamilyCassaWiseCreateRecipientSwiftRequest,
    params: RequestParams = {},
  ) =>
    this.request<ApiFamilyCassaWiseCreateRecipientResponse, ApiBaseError>({
      path: `/gtw/llm-socket/family-cassa/wise/recipient/swift`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Family Cassa
   * @name FamilyCassaWisePatchQuoteFamilyCassaWiseQuotePatchPost
   * @summary Wise smart import: patch quote with selected recipient
   * @request POST:/gtw/llm-socket/family-cassa/wise/quote/patch
   * @secure
   * @response `200` `ApiFamilyCassaWisePatchQuoteResponse` Successful Response
   * @response `422` `ApiHTTPValidationError` Validation Error
   */
  familyCassaWisePatchQuoteFamilyCassaWiseQuotePatchPost = (
    data: ApiFamilyCassaWisePatchQuoteRequest,
    params: RequestParams = {},
  ) =>
    this.request<ApiFamilyCassaWisePatchQuoteResponse, ApiBaseError>({
      path: `/gtw/llm-socket/family-cassa/wise/quote/patch`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Family Cassa
   * @name FamilyCassaWiseCreateTransferFamilyCassaWiseTransferPost
   * @summary Wise smart import: create transfer from quote and recipient
   * @request POST:/gtw/llm-socket/family-cassa/wise/transfer
   * @secure
   * @response `200` `ApiFamilyCassaWiseCreateTransferResponse` Successful Response
   * @response `422` `ApiHTTPValidationError` Validation Error
   */
  familyCassaWiseCreateTransferFamilyCassaWiseTransferPost = (
    data: ApiFamilyCassaWiseCreateTransferRequest,
    params: RequestParams = {},
  ) =>
    this.request<ApiFamilyCassaWiseCreateTransferResponse, ApiBaseError>({
      path: `/gtw/llm-socket/family-cassa/wise/transfer`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Family Cassa
   * @name FamilyCassaWiseFundTransferFamilyCassaWiseTransferFundPost
   * @summary Wise smart import: fund transfer from balance (may require SCA)
   * @request POST:/gtw/llm-socket/family-cassa/wise/transfer/fund
   * @secure
   * @response `200` `ApiFamilyCassaWiseFundTransferResponse` Successful Response
   * @response `422` `ApiHTTPValidationError` Validation Error
   */
  familyCassaWiseFundTransferFamilyCassaWiseTransferFundPost = (
    data: ApiFamilyCassaWiseFundTransferRequest,
    params: RequestParams = {},
  ) =>
    this.request<ApiFamilyCassaWiseFundTransferResponse, ApiBaseError>({
      path: `/gtw/llm-socket/family-cassa/wise/transfer/fund`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Family Cassa
   * @name FamilyCassaWiseDepositDetailsFamilyCassaWiseTransferDepositDetailsPost
   * @summary Wise smart import: get bank transfer deposit details for funding
   * @request POST:/gtw/llm-socket/family-cassa/wise/transfer/deposit-details
   * @secure
   * @response `200` `ApiFamilyCassaWiseDepositDetailsResponse` Successful Response
   * @response `422` `ApiHTTPValidationError` Validation Error
   */
  familyCassaWiseDepositDetailsFamilyCassaWiseTransferDepositDetailsPost = (
    data: ApiFamilyCassaWiseDepositDetailsRequest,
    params: RequestParams = {},
  ) =>
    this.request<ApiFamilyCassaWiseDepositDetailsResponse, ApiBaseError>({
      path: `/gtw/llm-socket/family-cassa/wise/transfer/deposit-details`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * @description Accepts one or more images. - If `enqueue=false` (default) — returns synchronous `ExtractResponse`. - If `enqueue=true` and queue is enabled — creates a job and returns `{ job_id, total: 1 }`. Results are available via `GET /jobs/{job_id}`. `file_ids` — optional JSON array of strings matching the uploaded files order for end-to-end identification.
   *
   * @tags Extraction
   * @name HttpExtractFromImagesExtractFromImagesPost
   * @summary Extract structured data from images
   * @request POST:/gtw/llm-socket/extract/from-images
   * @secure
   * @response `200` `ApiExtractFromImagesResponse` Synchronous result (`ExtractResponse`) or `{ job_id, total }` when enqueued
   * @response `400` `void` Validation error
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   * @response `422` `ApiHTTPValidationError` Validation Error
   * @response `500` `void` Internal server error
   */
  httpExtractFromImagesExtractFromImagesPost = (
    data: ApiBodyHttpExtractFromImagesExtractFromImagesPost,
    params: RequestParams = {},
  ) =>
    this.request<ApiExtractFromImagesResponse, ApiBaseError>({
      path: `/gtw/llm-socket/extract/from-images`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.FormData,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * @description Returns jobs created by the authenticated user (indexed by JWT subject).
   *
   * @tags Extraction
   * @name HttpListJobsBySubJobsBySubGet
   * @summary List jobs for current user (by JWT sub)
   * @request GET:/gtw/llm-socket/jobs/by-sub
   * @secure
   * @response `200` `ApiJobListResponse` List of user's jobs
   * @response `400` `void` Missing sub in token
   * @response `401` `void` Unauthorized
   * @response `422` `ApiHTTPValidationError` Validation Error
   * @response `500` `void` Result store not available
   */
  httpListJobsBySubJobsBySubGet = (
    query?: {
      /* Template custom: data-contract-jsdoc */
      offset?: number;
      /* Template custom: data-contract-jsdoc */
      limit?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<ApiJobListResponse, ApiBaseError>({
      path: `/gtw/llm-socket/jobs/by-sub`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * @description Creates a SINGLE job for the entire list; each file becomes an item within this job. - For PDFs, a smart pre-processor is applied: text pages are merged; empty/image pages are rendered. - Returns `{ job_id, total }`, where `total` equals the number of files. Progress and results — `GET /jobs/{job_id}`. `file_ids` (optional) — array of strings in the same order as files for end-to-end mapping.
   *
   * @tags Extraction
   * @name HttpExtractBatchExtractBatchPost
   * @summary Batch processing of PDFs and/or images via queue
   * @request POST:/gtw/llm-socket/extract/batch
   * @secure
   * @response `200` `ApiBatchStartResponse` Batch job created
   * @response `400` `void` Queue is not enabled or invalid input
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   * @response `422` `ApiHTTPValidationError` Validation Error
   * @response `500` `void` Internal server error
   */
  httpExtractBatchExtractBatchPost = (
    data: ApiBodyHttpExtractBatchExtractBatchPost,
    params: RequestParams = {},
  ) =>
    this.request<ApiBatchStartResponse, ApiBaseError>({
      path: `/gtw/llm-socket/extract/batch`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.FormData,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * @description Accepts JSON list of items {file_id, content_uri, mime?, symmetric_key?}. - Service only enqueues the job; workers fetch s3:// and process asynchronously. - If symmetric_key is provided, content is decrypted as AES-GCM (nonce(12) + ciphertext + tag(16)). - Returns { job_id, total }.
   *
   * @tags Extraction
   * @name HttpExtractBatchByUriExtractBatchByUriPost
   * @summary Batch processing of files by s3:// URI via queue
   * @request POST:/gtw/llm-socket/extract/batch/by-uri
   * @secure
   * @response `200` `ApiBatchStartResponse` Successful Response
   * @response `422` `ApiHTTPValidationError` Validation Error
   */
  httpExtractBatchByUriExtractBatchByUriPost = (
    data: ApiBatchByUriInput,
    params: RequestParams = {},
  ) =>
    this.request<ApiBatchStartResponse, ApiBaseError>({
      path: `/gtw/llm-socket/extract/batch/by-uri`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * @description Accepts a list of files belonging to one document (asset, ID, or personal document). `kind` — document type: `asset` | `id_document` | `personal_document`. If omitted, auto-detected from the first file. `subtype_hint` — asset type (e.g. `BrokerageAccount`) or ID type (e.g. `passport`); skips the classification LLM call. All files are fetched by workers and processed as a single batch. Returns `{job_id, total: 1}`.
   *
   * @tags Extraction
   * @name HttpExtractDocumentFromUrisExtractDocumentFromUrisPost
   * @summary Extract structured data from S3 URIs via queue (async)
   * @request POST:/gtw/llm-socket/extract/document-from-uris
   * @secure
   * @response `200` `ApiBatchStartResponse` Successful Response
   * @response `422` `ApiHTTPValidationError` Validation Error
   */
  httpExtractDocumentFromUrisExtractDocumentFromUrisPost = (
    data: ApiDocumentExtractByUriInput,
    params: RequestParams = {},
  ) =>
    this.request<ApiBatchStartResponse, ApiBaseError>({
      path: `/gtw/llm-socket/extract/document-from-uris`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * @description Accepts a list of files belonging to one document (asset, ID, or personal document). `kind` — document type: `asset` | `id_document` | `personal_document`. If omitted, auto-detected from the first file. `subtype_hint` — asset type (e.g. `BrokerageAccount`) or ID type (e.g. `passport`); skips the classification LLM call. All files are fetched by workers and processed as a single batch. Returns `{job_id, total: 1}`.
   *
   * @tags Extraction
   * @name HttpExtractDocumentFromUrisExtractDocumentFromUrisPost
   * @summary Extract structured data from S3 URIs via queue (async)
   * @request POST:/gtw/llm-socket/extract/document-from-uris
   * @secure
   * @response `200` `ApiBatchStartResponse` Successful Response
   * @response `422` `ApiHTTPValidationError` Validation Error
   */
  httpExtractDocumentFromUrisExtractDocumentFromUrisPost = (
    data: ApiDocumentExtractByUriInput,
    params: RequestParams = {},
  ) =>
    this.request<ApiBatchStartResponse, ApiBaseError>({
      path: `/gtw/llm-socket/extract/document-from-uris`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * @description Accepts one or more files (jpg/png/pdf) that all describe the same asset (e.g. bank statement + account agreement). All documents are sent to the LLM in a single prompt so that a unified result is synthesized. `asset_type_hint` — optional asset type string; skips the classification LLM call. `file_ids` — optional JSON array of strings matching the uploaded files order.
   *
   * @tags Extraction
   * @name HttpExtractAssetFromFilesExtractAssetFromFilesPost
   * @summary Extract structured asset data from multiple documents belonging to one asset
   * @request POST:/gtw/llm-socket/extract/asset-from-files
   * @secure
   * @response `200` `ApiAssetExtractResponse` Unified asset extraction result
   * @response `400` `void` Validation error
   * @response `401` `void` Unauthorized
   * @response `422` `ApiHTTPValidationError` Validation Error
   * @response `500` `void` Internal server error
   */
  httpExtractAssetFromFilesExtractAssetFromFilesPost = (
    data: ApiBodyHttpExtractAssetFromFilesExtractAssetFromFilesPost,
    params: RequestParams = {},
  ) =>
    this.request<ApiAssetExtractResponse, ApiBaseError>({
      path: `/gtw/llm-socket/extract/asset-from-files`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.FormData,
      format: 'json',
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * @description Returns job document: status (`pending`/`done`), `total`, `done`, `errors`, `results` and `pending_indexes`. `results` entries are normalized: always an array; for a single-task job there is one entry. `pending_indexes` — indexes (0..total-1) that are still in progress. `pending_stale_indexes` — subset of pending indexes that exceeded the dynamic timeout (`per_file_timeout * total`).
   *
   * @tags Extraction
   * @name HttpGetJobJobsJobIdGet
   * @summary Job status and results
   * @request GET:/gtw/llm-socket/jobs/{job_id}
   * @secure
   * @response `200` `ApiJobDocument` Current state or final results
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   * @response `404` `void` Job not found
   * @response `422` `ApiHTTPValidationError` Validation Error
   * @response `500` `void` Internal server error
   */
  httpGetJobJobsJobIdGet = (jobId: string, params: RequestParams = {}) =>
    this.request<ApiJobDocument, ApiBaseError>({
      path: `/gtw/llm-socket/jobs/${jobId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * @description Health check endpoint.
   *
   * @tags Monitoring
   * @name HealthCheckHealthGet
   * @summary Service health check
   * @request GET:/gtw/llm-socket/health
   * @secure
   * @response `200` `any` Successful Response
   */
  healthCheckHealthGet = (params: RequestParams = {}) =>
    this.request<any, ApiBaseError>({
      path: `/gtw/llm-socket/health`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Monitoring
   * @name MetricsMetricsGet
   * @summary Prometheus metrics
   * @request GET:/gtw/llm-socket/metrics
   * @secure
   * @response `200` `any` Successful Response
   */
  metricsMetricsGet = (params: RequestParams = {}) =>
    this.request<any, ApiBaseError>({
      path: `/gtw/llm-socket/metrics`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * @description Detailed service status.
   *
   * @tags Monitoring
   * @name StatusStatusGet
   * @summary Extended service status
   * @request GET:/gtw/llm-socket/status
   * @secure
   * @response `200` `any` Successful Response
   */
  statusStatusGet = (params: RequestParams = {}) =>
    this.request<any, ApiBaseError>({
      path: `/gtw/llm-socket/status`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
}
